import React, { useState } from 'react';
import { orderBy } from 'lodash';
import {
  CustomBasicRefinement,
  CustomClearRefinements,
  CustomRangeSliderRefinement,
  CustomSearchRefinement,
  CustomTrueFalseRefinement
} from '@components/atoms/education/refinement/educationRefinement';
import StyledEducationLibraryFilter from './educationLibraryFilter.style';

export const EducationLibraryFilterContext = React.createContext();

function EducationLibraryFilter() {
  const [isFilterReset, setIsFilterReset] = useState(false);

  return (
    <StyledEducationLibraryFilter>
      <EducationLibraryFilterContext.Provider
        value={{
          isFilterReset,
          setIsFilterReset
        }}
      >
        <div className="library-filter__grid">
          <CustomSearchRefinement headline="Suche" />
          <CustomRangeSliderRefinement headline="Dauer" attribute="durationFilter" />
          <CustomBasicRefinement headline="Inhaltstypen" attribute="typeFilter" />
          <CustomTrueFalseRefinement
            headline="level: gut zum einstieg"
            attribute="beginner"
            transformItems={items => orderBy(items, 'label', 'desc')}
          />
          <CustomTrueFalseRefinement
            headline="digitales gerät erforderlich"
            attribute="digitalDevice"
            transformItems={items => orderBy(items, 'label', 'desc')}
          />
          <CustomTrueFalseRefinement
            headline="Zukunftbox vorhanden"
            attribute="futureBox"
            transformItems={items => orderBy(items, 'label', 'desc')}
          />
          <CustomClearRefinements />
        </div>
      </EducationLibraryFilterContext.Provider>
    </StyledEducationLibraryFilter>
  );
}

export default EducationLibraryFilter;
